"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M7.061 7.061C7.20039 6.9217 7.31096 6.7563 7.38641 6.57425C7.46185 6.3922 7.50068 6.19706 7.50068 6C7.50068 5.80294 7.46185 5.6078 7.38641 5.42575C7.31096 5.2437 7.20039 5.0783 7.061 4.939C6.475 4.354 1 1 1 1C1 1 4.354 6.475 4.939 7.061C5.0783 7.20039 5.2437 7.31096 5.42575 7.38641C5.6078 7.46185 5.80294 7.50068 6 7.50068C6.19706 7.50068 6.3922 7.46185 6.57425 7.38641C6.7563 7.31096 6.9217 7.20039 7.061 7.061Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6 0C5.73478 0 5.48043 0.105357 5.29289 0.292893C5.10536 0.48043 5 0.734784 5 1C5 1.26522 5.10536 1.51957 5.29289 1.70711C5.48043 1.89464 5.73478 2 6 2C6.79113 2 7.56448 2.2346 8.22228 2.67412C8.88008 3.11365 9.39277 3.73836 9.69552 4.46927C9.99827 5.20017 10.0775 6.00444 9.92314 6.78036C9.7688 7.55629 9.38784 8.26902 8.82843 8.82843C8.26902 9.38784 7.55629 9.7688 6.78036 9.92314C6.00444 10.0775 5.20017 9.99827 4.46927 9.69552C3.73836 9.39277 3.11365 8.88008 2.67412 8.22228C2.2346 7.56448 2 6.79113 2 6C2 5.73478 1.89464 5.48043 1.70711 5.29289C1.51957 5.10536 1.26522 5 1 5C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6C0 7.18669 0.351894 8.34673 1.01118 9.33342C1.67047 10.3201 2.60754 11.0892 3.7039 11.5433C4.80026 11.9974 6.00666 12.1162 7.17054 11.8847C8.33443 11.6532 9.40353 11.0818 10.2426 10.2426C11.0818 9.40353 11.6532 8.33443 11.8847 7.17054C12.1162 6.00666 11.9974 4.80026 11.5433 3.7039C11.0892 2.60754 10.3201 1.67047 9.33342 1.01118C8.34673 0.351894 7.18669 0 6 0V0Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;